function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Icon } from '../../../../components/icon';
export var IconExclamationTriangleError = props => {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 20 20",
    width: "100%",
    height: "100%"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.375 20h19.249c.29 0 .469-.36.325-.648L10.324.215a.35.35 0 0 0-.649 0L.051 19.352c-.145.288.035.648.324.648",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.375 20h19.249c.29 0 .469-.36.326-.648L10.324.216a.35.35 0 0 0-.649 0L.051 19.352c-.145.288.035.648.324.648M10.8 16.8h-2v-2.4h2m0-1.6h-2V7.2h2",
    fill: "#a11"
  }));
};